var _path, _path2, _g, _path3, _g2, _path4, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72994 1.8337C2.48317 2.09718 2.35156 2.49239 2.35156 3.00287V21.4789C2.35156 21.9894 2.49962 22.4011 2.72994 22.6481L2.79575 22.714L13.1436 12.3562V12.1092L2.79575 1.7843L2.72994 1.85017",
    fill: "#5AC9F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11862_133236",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 8,
    width: 9,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5828 15.8301L13.1445 12.372V12.125L16.5993 8.66687L20.7615 11.0381C21.9295 11.6968 21.9295 12.7836 20.7615 13.4423L16.6816 15.7642L16.5993 15.8136",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11862_133236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8974 8.68311H13.1289V15.8298H21.8974V8.68311Z",
    fill: "url(#paint0_linear_11862_133236)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11862_133236",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 12,
    width: 15,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6639 15.7823L13.1433 12.2583L2.74609 22.6655C3.12447 23.0772 3.76607 23.1266 4.47348 22.7149L16.6639 15.7823Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11862_133236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70526 5.27452L-2.69531 17.687L9.70526 30.0995L22.1058 17.687L9.70526 5.27452Z",
    fill: "url(#paint1_linear_11862_133236)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11862_133236",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 15,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6639 8.71659L4.47348 1.78395C3.76607 1.37227 3.12447 1.42167 2.74609 1.83335L13.1433 12.2405L16.6639 8.71659Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11862_133236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70917 -5.60548L-2.69141 6.80701L9.70917 19.2195L22.1097 6.80701L9.70917 -5.60548Z",
    fill: "url(#paint2_linear_11862_133236)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11862_133236",
    x1: 20.247,
    y1: 12.5371,
    x2: -0.0403426,
    y2: 12.5371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBBD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F9A417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11862_133236",
    x1: 14.3528,
    y1: 13.1011,
    x2: -4.74519,
    y2: 32.1808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6176D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11862_133236",
    x1: -4.75809,
    y1: -8.61546,
    x2: 10.8362,
    y2: 6.96389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269E6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2BA06E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#52B26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6BBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74C168"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.9a76df3ee6e2de2d1bae6597f8f84544.svg";
export { ForwardRef as ReactComponent };